<template>
  <div class="entry-main">
    <ButtonBack class="mb_m"/>
    <div class="table">
      <div class="table-header">
        <div class="table-header-created-at">
          申請日
        </div>

        <div class="table-header-user-id">
          ユーザー名
        </div>

        <div class="table-header-allowed">
          参加
        </div>

        <div class="table-header-actions">
          アクション
        </div>
      </div>

      <div
        v-for="(entry, index) in entries"
        :key="index"
        class="table-cell"
        @click="allow(entry)"
        >

        <div class="table-cell-created-at">
          {{ $store.getters['date/createdAt'](entry) }}
        </div>

        <div class="table-cell-user-id">
          <link-edit-user :model="entry" />
        </div>

        <div class="table-cell-allowed">
          {{ entry.get('allowed').get('ja') }}
        </div>

        <div class="table-cell-action">
          <icon-remove :entry="entry" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ButtonBack from '@/components/ButtonBack'
import LinkEditUser from '@/components/User/LinkEditUser'
import MixinResultHandler from '@/components/MixinResultHandler'
import IconRemove from '@/components/Entry/IconRemove'

export default {
  mixins: [
    MixinResultHandler
  ],

  components: {
    ButtonBack,
    LinkEditUser,
    IconRemove
  },

  computed: {
    ...mapState('entry', [
      'entries'
    ])
  },

  methods: {
    allow: async function (entry) {
      const message = this.$store.getters['entry/allowMessage'](entry)
      if (window.confirm(message)) {
        const result = await this.$store.dispatch('entry/allow', entry)
        this.showSnack(result)
        this.$store.dispatch('entry/retrieveEntries', this.$route.params.id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin cell {
  &-created-at {
    padding: 5px;
    width: 10%;
  }

  &-user-id {
    padding: 5px;
    width: 45%;
  }

  &-allowed {
    padding: 5px;
    width: 10%;
  }

  &-action {
    padding: 5px;
    width: 20%;
  }
}

@import '@/styles/_table.scss';
@import '@/styles/_icon.scss';
</style>
